import { useEffect } from 'react';
import useAuth from './useAuth';
import { useDispatch } from 'react-redux';
import {
    clearUserAllowedFeatures,
    setUserAllowedFeatures,
} from '../store/UserAllowedFeatures/UserAllowedFeaturesSlice';
import { fetchUserTest } from '../api/userTest';

const useUserAllowedFeatures = () => {
    const auth = useAuth();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!auth.user || !auth.user.user_id || !auth.user.role) {
            dispatch(clearUserAllowedFeatures());
            return;
        }
        const fetchUserAllowedFeatures = async () => {
            try {
                const res = await fetchUserTest();
                if (res) {
                    dispatch(setUserAllowedFeatures(res));
                }
            } catch (error) {
                console.error('Error fetching user allowed features:', error);
            }
        };
        if (auth.user.role === 'DR') {
            fetchUserAllowedFeatures();
        }

        return () => {
            dispatch(clearUserAllowedFeatures());
        };
    }, [auth.user?.user_id, auth.user?.role]);
};

export default useUserAllowedFeatures;
